const CREATE_NEW = 'Create new';
const SAVE = 'Save';
const CLOSE = 'Close';

const SMS_TITLE = 'Sms title';
const SMS_TEXT = 'Sms text';
const TYPE_MESSAGE_TEXT = 'Type message text';
const SMS_TYPE = 'Sms type';
const SMS_CATEGORY = 'Sms category';
const LINK_LIST = [
  {
    value: 'orderDetailsUrl',
    label: 'Order details',
    text: 'Order details',
  },
  {
    value: 'trackPageUrl',
    label: 'Track page',
    text: 'Track page',
  },
  {
    value: 'memoyaCloudLink',
    label: 'Cloud link',
    text: 'Cloud link',
  },
  {
    value: 'contactUsLink',
    label: 'Contact Page',
    text: 'Contact Page',
  },
  {
    value: 'proofPageLink',
    label: 'Proof page',
    text: 'Proof page',
  },
];

const VARIABLE_LIST = [
  {
    value: 'clientName',
    label: 'Client Name',
    text: 'Client Name',
  },
  {
    value: 'message',
    label: 'Message',
    text: 'Message',
  },
  {
    value: 'orderId',
    label: 'Order ID',
    text: 'Order ID',
  },
  {
    value: 'orderMessageLink',
    label: 'Order Message Link',
    text: 'Order Message Link',
  },
];

const TYPE_MESSAGE_TEXT_LIST = [
  {
    value: 'usual',
    label: 'Usual',
    text: 'Usual',
  },
  {
    value: 'hardcode',
    label: 'Hardcode',
    text: 'Hardcode',
  },
];

const CATEGORY_LIST = [
  { value: null, label: 'All categories', text: 'All categories' },
  { value: 'generalReceive', label: 'General Receive', text: 'General Receive' },
  { value: 'enhance', label: 'Enhance', text: 'Enhance' },
  { value: 'create', label: 'Create', text: 'Create' },
  { value: 'giftCard', label: 'Gift', text: 'Gift' },
  { value: 'digitize', label: 'Digitize', text: 'Digitize' },
  { value: 'foreverCloud', label: 'Forever Cloud', text: 'Forever Cloud' },
  { value: 'giftWrapping', label: 'Gift wrapping', text: 'Gift wrapping' },
  { value: 'qa', label: 'QA', text: 'QA' },
  { value: 'generalDelivery', label: 'General Delivery', text: 'General Delivery' },
  { value: 'other', label: 'Other', text: 'Other' },
];

const TYPE_LIST = [
  { value: null, label: 'All types', text: 'All types' },
  { value: 'TEXT', label: 'Text', text: 'Text' },
  { value: 'AUDIO', label: 'Audio', text: 'Audio' },
];

export {
  CREATE_NEW,
  SAVE,
  CLOSE,
  LINK_LIST,
  SMS_TITLE,
  SMS_TEXT,
  CATEGORY_LIST,
  TYPE_LIST,
  VARIABLE_LIST,
  TYPE_MESSAGE_TEXT,
  TYPE_MESSAGE_TEXT_LIST,
  SMS_TYPE,
  SMS_CATEGORY,
};
